import { supportLinks } from '@va/constants';
import Config from 'Config';
import { openChatwootWidget } from '../chatwoot';

export const onContactSupport = () => {
  if (!Config.chatwootToken) {
    window.open(supportLinks.contact, '_blank');
    return;
  }

  openChatwootWidget();
};
